import {Directive, ElementRef, HostListener} from '@angular/core';

/**
 * otunctan
 */
@Directive({
    selector: '[charactersOnly]',
  standalone: false
})
export class AllowCharacterDirective {

    regexStr: string = '^[a-zA-ZçğıöşüÇĞİÖŞÜ ]+$';

    constructor(private _el: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
    public onKeyPress(event: KeyboardEvent) {
        return new RegExp(this.regexStr).test(event.key);
    }

    @HostListener('paste', ['$event'])
    blockPaste(event: ClipboardEvent) {
        this.validationFields(event);
    }

    validationFields(event: ClipboardEvent) {
        event.preventDefault();
        const pasteData = event.clipboardData?.getData('text/plain').replace(/[^çğıöşüÇĞİÖŞÜ ]/g, '');
        document.execCommand('insertHTML', false, pasteData);
    }


}
